/**
 * /settings/guardrails/add — the batch add-rules workflow. `?to=<policyId>`
 * preselects the target document (the review screen's "Save & add rules"
 * chains here with it).
 */
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Skeleton } from '@servicecompressionllc/sc-design-system';
import { AppShell } from '../../components/AppShell.js';
import { useMe } from '../../hooks/useMe.js';
import { AddRuleView } from './AddRuleView.js';
import { usePoliciesListLogic } from './useGuardrailsLogic.js';
import { GUARDRAILS_PATH } from './shared.js';

export const AddRulesPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const meQuery = useMe();
  const tenantId = meQuery.data?.tenant.id;
  const policiesQuery = usePoliciesListLogic(tenantId);

  if (meQuery.isLoading || !tenantId || policiesQuery.isLoading) {
    return (
      <AppShell>
        <Skeleton className="mb-6 h-5 w-64" />
        <Skeleton className="mx-auto h-96 w-full max-w-[780px] rounded-xl" />
      </AppShell>
    );
  }

  const toList = () => navigate(GUARDRAILS_PATH);

  return (
    <AppShell>
      <AddRuleView
        tenantId={tenantId}
        policies={policiesQuery.data ?? []}
        initialTargetId={searchParams.get('to') ?? undefined}
        onDone={toList}
        onCancel={toList}
      />
    </AppShell>
  );
};
